function splitText(text?: string) {
  if (!text) return ['', '']
  if (!text.startsWith('#')) return ['', text]
  // TODO handle case where there is no newline
  if (!text.includes('\n')) {
    return text.startsWith('#') ? [text.slice(2), ''] : [text, '']
  }
  const index = text.indexOf('\n')
  const description = text.slice(index + 1)
  return [text.slice(2, index), description.startsWith('# ') ? description.slice(2) : description]
}

export { splitText }
